<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">An epic of the first manned mission to Mars, created by political mastermind Allen Drury, Pulitzer Prize-winning author of <i>Advise and Consent</i>.</p>
<p class="subsq">After showing us the deep inner workings of Washington politics, Allen Drury turns his keen, dissecting eye on a complex space mission—the drama, the suspense, and the politics of America’s race to put the first human on the planet Mars.</p>
<p class="subsq">Mission Commander Conrad Trasker faces countless problems and challenges—a maverick veteran astronaut who demands a place on the crew; a moody, crusading doctor, whose refusal to cooperate jeopardizes the lives of his crewmates; a union leader who tries to sabotage the flight for sinister political purposes; and a constant barrage of criticism from ambitious politicians and the nation’s media.</p>
<p class="subsq">Against this background, Trasker and Planetary Fleet One plunge toward their rendezvous deep in interplanetary space … and a crisis that threatens not only the lives of the crew, but the entire future of American leadership in space.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookdescription.vue?0b26e361